export default {
   get: 'GET',
   post: 'POST',
};